var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgItalyFlag = function SvgItalyFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "444.5 896.5 300 200",
    xmlSpace: "preserve"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#009246",
    d: "M444.5 896.5h100v200h-100z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M544.5 896.5h100v200h-100z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE2B37",
    d: "M644.5 896.5h100v200h-100z"
  })))));
};
export default SvgItalyFlag;